import Assortiment from "@/views/Assortiment.vue";
import Application from "@/views/Application.vue";
import Collecties from "@/views/Collecties.vue";
import Products from "@/views/Products.vue";
import Specifications from "@/views/Specifications.vue";
import Outro from "@/views/Outro.vue";

// extra scripts
import trompetty from "@/scripts/trompetty.js";
import routeNames from "@/router/routes/names.js";

const lang = "en-EN";

// nameCode is to make every route name unique
const langSplit = lang.split("-");
const nameCode = langSplit[0];

const productsData = trompetty.buildProductData(lang);

let assortmentList = trompetty.buildAssortimentRouting(lang);
let collectieList = trompetty.buildCollectionRouting(lang);
let productList = trompetty.BuildProductRoute(productsData);

const views = [
  {
    path: "/",
    name: `${nameCode}-${routeNames.assortment}`,
    component: Assortiment,
    lang: lang,
    step: 1,
  },
  {
    path: "/en",
    name: `${nameCode}-${routeNames.assortment}${nameCode.toUpperCase()}`,
    component: Assortiment,
    lang: lang,
    step: 1,
  },
  {
    path: "/application",
    name: `${nameCode}-${routeNames.application}`,
    component: Application,
    lang: lang,
    step: 4,
  },
  {
    path: "/thanks",
    name: `${nameCode}-${routeNames.outro}`,
    component: Outro,
    lang: lang,
    step: 1,
  },
];

const assortimenten = [];

// create assortment routing
let iassortimenten = assortimenten.length;

for (const assortmentKey in assortmentList) {
  let component = Collecties;

  if (Object.keys(collectieList[assortmentKey]).length === 1) {
    component = Products;
  }

  assortimenten[iassortimenten] = {
    path: `/${assortmentList[assortmentKey].path}`,
    name: `${nameCode}-${assortmentKey}`,
    component: component,
    lang: lang,
    step: 1,
  };

  iassortimenten++;
}

const collecties = [];

let iCollectie = collecties.length;

// create path All
for (const assortiment in assortimenten) {
  let name = assortimenten[assortiment].name;

  if (assortimenten[assortiment].name.includes("-")) {
    let nameArray = assortimenten[assortiment].name.split("-");
    name = nameArray[1];
  }

  collecties[iCollectie] = {
    path: (
      assortimenten[assortiment].path.replaceAll(" ", "") + "/alle"
    ).toLowerCase(),
    name: `${nameCode}-${name}ALL`,
    component: Products,
    lang: lang,
    step: 2,
  };
  iCollectie++;
}

// get assortiment path
for (const assortmentKey in assortmentList) {
  // get collecties path

  for (const collectionKey in collectieList[assortmentKey]) {
    collecties[iCollectie] = {
      path: (
        "/" +
        assortmentList[assortmentKey].path +
        "/" +
        collectieList[assortmentKey][collectionKey].path
      )
        .toLowerCase()
        .replaceAll(" ", "-"),
      name: `${nameCode}-${collectieList[assortmentKey][collectionKey].name}`,
      component: Products,
      lang: lang,
      step: 2,
    };
    iCollectie++;
  }
}

// create product paths from list
const products = [];

let iProduct = products.length;

for (const assortimentenKey in assortmentList) {
  for (const collectionKey in productList) {
    if (assortimentenKey === collectionKey) {
      for (const productKey in productList[collectionKey]) {
        products[iProduct] = {
          path: `/${assortmentList[assortimentenKey].path}/${productList[
            collectionKey
          ][productKey].path.toLowerCase()}`,
          name: `${nameCode}-${productList[collectionKey][productKey].name}`,
          component: Specifications,
          lang: lang,
          step: 3,
        };
        iProduct++;
      }
    }
  }
}

const paths = {
  assortimenten,
  collecties,
  products,
  views,
};

export default paths;
